import { IResponsePharmacySupplies } from 'shared/interfaces/supply.interface';
import { http } from '../utils/axios';

class SuppliesService {
  private static instance: SuppliesService;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  static getInstance(): SuppliesService {
    if (!SuppliesService.instance) {
      SuppliesService.instance = new SuppliesService();
    }

    return SuppliesService.instance;
  }

  getPharmacySupplies = async (payload: { pharmacyId: string }) => {
    const { data } = await http<IResponsePharmacySupplies>({
      url: '/supplies?page=1&limit=100',
      method: 'GET',
      params: {
        pharmacy: payload.pharmacyId
      }
    });

    return data;
  };
}

const instance = SuppliesService.getInstance();

export default instance;
